import React from 'react';

import styled from 'styled-components';

import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from "@material-ui/core/TextField";

import { MANWOM } from './appEnums';

const StyledFormControl = styled(FormControl)`
  && { width: 100%;}
`
const StyledTextField = styled(TextField)`
  && {
    width: 100%;
  }
`;
const MenSelect = ({value, setValue, i18next}) => {

  const handleChange = (event) => setValue(event.target.value);

  return (
    <StyledFormControl>
      {/* <InputLabel htmlFor="malefemale-select">{i18next.t("Male or Female")}</InputLabel> */}
      <StyledTextField
        disabled
        id="standard-name"
        label={i18next.t("Male or Female")}
        margin="normal"
        rows="0"
        inputProps={{
          style: i18next.language === "fa" ? { fontFamily: "BYekan" } : {},
        }} // font of input text
        InputLabelProps={{
          style: i18next.language === "fa" ? { fontFamily: "BYekan" } : {},
        }} // font of input label
      />
      <Select
        value={i18next.t(value)}
        onChange={handleChange}
        inputProps={{
          name: 'malefemale',
          id: 'malefemale-select'
        }}
        style={i18next.language === "fa" ? {fontFamily:"BYekan"} : {}}
      >
        {
          MANWOM.map(MF => <MenuItem style={i18next.language === "fa" ? {fontFamily:"BYekan"}: {}} key={MF.CODE} value={MF.CODE}>{i18next.t(MF.NAME)}</MenuItem>)
        }
      </Select>
      {/* <FormHelperText>{i18next.t("Please choose Male or Female")}</FormHelperText> */}
    </StyledFormControl>
  );
};

export default MenSelect;
